export const elsCertifications = [
  {
    title: 'eLearnSecurity Junior Penetration Tester',
    description:
      'The eLearnSecurity Junior Penetration Tester certification demonstrates your newly learned cyber security skills. For IT professionals looking for meaningful jobs in the industry, the eJPT certification proves to employers that you have the prerequisite training necessary for a career in cyber security.',
    version: 1,
    logo: 'https://assets.ine.com/els-static/els-certs/ejpt.png',
    url: 'https://elearnsecurity.com/product/ejpt-certification/',
  },
  {
    title: 'eLearnSecurity Certified Professional Penetration Tester',
    description:
      'Join IT professionals around the world by passing eLearnSecurity’s Certified Professional Penetration Tester certification. The certification involves in-depth penetration testing that simulates a real-world scenario and is hand-graded by a security professional.',
    version: 2,
    logo: 'https://assets.ine.com/els-static/els-certs/ecpptv2.png',
    url: 'https://elearnsecurity.com/product/ecpptv2-certification/',
  },
  {
    title: 'eLearnSecurity Certified Threat Hunting Professional',
    description:
      'eLearnSecurity’s Certified Threat Hunting Professional is an expert-level in threat hunting and threat identification in general. Students are tested through real-world scenarios modeled after cutting-edge malware that simulates corporate network vulnerabilities.',
    version: 2,
    logo: 'https://assets.ine.com/els-static/els-certs/ecthpv2.png',
    url: 'https://elearnsecurity.com/product/ecthpv2-certification/',
  },
  {
    title: 'eLearnSecurity Web application Penetration Tester',
    description:
      'Web Application Penetration Tester tests cyber security professionals through in-depth web application security questions and simulations. eWPT allows pentesters to prove their skills in one of cyber security’s fastest growing sectors.',
    version: 1,
    logo: 'https://assets.ine.com/els-static/els-certs/ewptv1.png',
    url: 'https://elearnsecurity.com/product/ewpt-certification/',
  },
  {
    title: 'eLearnSecurity Web application Penetration Tester eXtreme',
    description:
      'The eLearnSecurity Web application Penetration Tester eXtreme is our most advanced Pentesting certification. Prove your penetration skills through a rigorous simulation of real-world pentesting. Students who obtain their eWPTXv2 exam prove their expert pentesting abilities.',
    version: 2,
    logo: 'https://assets.ine.com/els-static/els-certs/ewptxv2.png',
    url: 'https://elearnsecurity.com/product/ewptxv2-certification/',
  },
  {
    title: 'eLearnSecurity Certified Penetration Tester eXtreme',
    description:
      'The eLearnSecurity Certified Penetration Tester eXtreme is the next step in eLearnSecurity’s penetration certifications. eCPTX is the most practical and advanced certification available on the market for the assessment of network penetration testing skills.',
    version: null,
    logo: 'https://assets.ine.com/els-static/els-certs/ecptx.png',
    url: 'https://elearnsecurity.com/product/ecptx-certification/',
  },
  {
    title: 'eLearnSecurity Certified Digital Forensics Professional',
    description:
      'eLearnSecurity’s Certified Digital Forensics Professional tests your digital forensics knowledge through a series of scenario-based examinations. Students are expected to complete a thorough digital forensics simulation that requires various methodologies.',
    version: null,
    logo: 'https://assets.ine.com/els-static/els-certs/ecdfp.png',
    url: 'https://elearnsecurity.com/product/ecdfp-certification/',
  },
  {
    title: 'eLearnSecurity Web Defense Professional',
    description:
      'eLearnSecurity’s Web Defense Professional is designed to test the skills of web application developers in the defense domain. An eWDP certification ensures that students have a strong understanding of the theoretical and concrete aspects of web app security defense.',
    version: null,
    logo: 'https://assets.ine.com/els-static/els-certs/ewdp.png',
    url: 'https://elearnsecurity.com/product/ewdp-certification/',
  },
  {
    title: 'eLearnSecurity Certified Reverse Engineer',
    description:
      'eLearnSecurity Certified Reverse Engineer certification covers a blend of theory and practical knowledge through both a pre-test multiple choice screening and a lab-based real-world scenario test. Students who pass ECRE demonstrate knowledge of thorough reverse engineering processes.',
    version: null,
    logo: 'https://assets.ine.com/els-static/els-certs/ecre.png',
    url: 'https://elearnsecurity.com/product/ecre-certification/',
  },
  {
    title: 'eLearnSecurity Certified Incident Responder',
    description:
      'eLearnSecurity’s Certified Incident Responder certification is ideal for blue team security professionals. The exam is designed to test the skills students learn in our Incident Handling & Response class and challenges you through advanced detection and analysis methodologies.',
    version: null,
    logo: 'https://assets.ine.com/els-static/els-certs/ecir.png',
    url: 'https://elearnsecurity.com/product/ecir-certification/',
  },
  {
    title: 'eLearnSecurity Network Defense Professional',
    description:
      'The eLearnSecurity Network Defense Professional certification ensures that students possess advanced knowledge of network defense, including security issue remediation and hardening a network from attack.',
    version: null,
    logo: 'https://assets.ine.com/els-static/els-certs/endp.png',
    url: 'https://elearnsecurity.com/product/endp-certification/',
  },
  {
    title: 'eLearnSecurity Mobile Application Penetration Tester',
    description:
      'The eLearnSecurity Mobile Application Penetration certificate shows students are ready to take on the challenges of mobile application security. Graded by industry experts and requiring a hands-on skills demonstration, eMAPT provides concrete evidence of mobile app security knowledge.',
    version: null,
    logo: 'https://assets.ine.com/els-static/els-certs/emapt.png',
    url: 'https://elearnsecurity.com/product/emapt-certification/',
  },
  {
    title: 'eLearnSecurity Certified eXploit Developer',
    description:
      'The eCXD Certified eXploit Developer is an advanced certification covering Windows and Linux exploit development and software vulnerability identification. Certification requires students to pass a practical exam involving complex exploit methodologies and alternate exploitation paths.',
    version: null,
    logo: 'https://assets.ine.com/els-static/els-certs/ecxd.png',
    url: 'https://elearnsecurity.com/product/ecxd-certification/',
  },
  {
    title: 'eLearnSecurity Certified Malware Analysis Professional',
    description:
      'eLearnSecurity’s Certified Malware Analysis Professional certification will require you to perform a full analysis on a given malware sample, show proof of what the malware does, and finally, write a signature that could be used to detect the malware sample on other systems or networks.',
    version: null,
    logo: 'https://assets.ine.com/els-static/els-certs/ecmap.png',
    url: 'https://elearnsecurity.com/product/ecmap-certification/',
  },
]
